import getQueryString from 'Common/getQueryString';
import isBodyStyle from 'Common/isBodyStyle';
import * as R from 'ramda';
import { readCookie } from 'utils/cookies';

export default (make, urlModel, ui, search, dealerId, currentUrl) => {
  const urlMake = !isBodyStyle(make) ? make : undefined;
  const urlBodystyle = isBodyStyle(make) ? make : undefined;
  let urlSearchValues = {};
  if (urlMake) urlSearchValues.urlmake = `{"key":"${urlMake}"}`;
  if (urlModel) urlSearchValues.urlmodel = `{"key":"${urlModel}"}`;
  if (urlBodystyle) urlSearchValues.urlcarType = `{"key":"${urlBodystyle}"}`;
  if (dealerId) urlSearchValues.dealerId = `{"key":"${dealerId}"}`;
  let qs = search.substr(1);
  let postCodeQuery = '';
  if (R.contains('postCode=', qs)) {
    if (!ui.postCode) {
      ui.postCode = {};
    }
    ui.postCode.isValid = true;
  } else {
    const lastPostCode = readCookie('lastPostCode');
    postCodeQuery = lastPostCode ? `postCode=${lastPostCode}` : '';
  }

  const queryFormUrl = getQueryString({ values: urlSearchValues });

  const query = queryFormUrl
    ? `${queryFormUrl}&${qs}&${postCodeQuery}&currentUrl=${currentUrl}`
    : `${qs}&${postCodeQuery}&currentUrl=${currentUrl}`;

  return query;
};



// WEBPACK FOOTER //
// ./src/Results/buildQuery/index.js